import { navigation } from '../constants/routes';

export const isSecuredRoute = path => {
  const route = navigation.find(item => item.path === path);
  return route ? route.isSecured : false;
};
